import React from 'react'
import { InputSwitch as PrimeInputSwitch } from 'primereact/inputswitch'

export default function InputSwitch (props) {
  return (
    <PrimeInputSwitch {...props} />
  )
}
